import styles from "./Card.module.css";

interface CardProps {
	children: React.ReactNode;
	className?: string;
	header?: React.ReactNode;
}

export function Card({ children, className, header }: CardProps) {
	return (
		<div className={[styles.card, className].filter(Boolean).join(" ")}>
			{header && <div className={styles.header}>{header}</div>}
			<div className={styles.body}>{children}</div>
		</div>
	);
}
